import { cn } from "@/lib/utils";
import { HugeiconsIcon } from "@hugeicons/react";
import { MailIcon, ChevronRightIcon } from "@/components/ui/icons";
import type { SearchOptionProps } from "./types";

export const InboxOption = ({
  option,
  isSelected,
  onClick,
}: SearchOptionProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        "flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-accent/20 transition-colors",
        isSelected && "bg-primary/10 text-primary!"
      )}
    >
      <div className="flex items-center gap-1 flex-1">
        <div
          className={cn(
            "flex h-8 w-8 shrink-0 items-center justify-center rounded-md border",
            isSelected && "border-primary text-primary!"
          )}
        >
          <HugeiconsIcon icon={MailIcon} size={16} />
        </div>
        <div
          className={cn(
            "text-sm font-medium text-foreground flex-1 truncate flex items-center gap-1 ml-1",
            isSelected && "text-primary!"
          )}
        >
          {option.lead_id && option.lead_title ? (
            <>
              <span>Go in Lead</span>
              <HugeiconsIcon icon={ChevronRightIcon} size={16} />
              <span className="font-semibold">{option.lead_title}</span>
              <HugeiconsIcon icon={ChevronRightIcon} size={16} />
              <span>Go to Inbox</span>
              <HugeiconsIcon icon={ChevronRightIcon} size={16} />
              <span className="font-semibold">{option.title}</span>
            </>
          ) : (
            <>
              Go to Inbox {">"}{" "}
              <span className="font-semibold">{option.title}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
